import React, { useContext, useEffect, useState } from "react";
import { CircularProgress, makeStyles } from "@material-ui/core";
import DialogAcerBrag from "../../components/UI/DialogAcerBrag";
import LimitedBackdrop from "../../components/UI/LimitedBackdrop";
import { separations } from "../../constants/StyleConstants";
import MaterialsRequiresAPI from "../../services/MaterialsRequiresAPI";
import { LoginContext } from "../../contexts/LoginContext";
import { AppContext } from "../../contexts/AppContext";

const useStyles = makeStyles((theme) => ({
  ...separations,
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    rowGap: ".4em",
  },
  serviceSheetsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontWeight: "bold",
    width: "100%",
    marginBottom: ".5em",
    padding: "0 .7em 0 .7em",
  },
  serviceSheets: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    backgroundColor: "rgba(0,0,0,.2)",
    padding: ".3em .8em .3em .8em",
    borderRadius: "4px",
    border: "1px solid rgba(0,0,0,.2)",
  },
}));

const MaterialsRequiresConfirmationDialog = ({
  open,
  setOpen,
  selectedRows,
  setSelectedRows,
  reloadGrid,
}) => {
  const classes = useStyles();
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const { showError, showSuccess } = useContext(AppContext);

  const confirmRequires = () => {
    setOpenBackDrop(true);

    const request = [];

    for (let i = 0; i < selectedRows.length; i++) {
      const item = selectedRows[i];

      const data = {
        id: item.id,
        materialDescription: item.name,
      };

      request.push(data);
    }

    return MaterialsRequiresAPI.delete(request)
      .then((res) => {
        showSuccess(
          "Los requerimientos de certificados seleccionados se han eliminado con éxito"
        );
        setSelectedRows([]);
        reloadGrid();
      })
      .catch((error) => {
        const errorMsg =
          "Error al confirmar las eliminaciones de los requerimientos de certificados";
        showError(errorMsg, error);
      })
      .finally(() => {
        setOpen(false);
        setTimeout(() => setOpenBackDrop(false), 250);
      });
  };

  return (
    <DialogAcerBrag
      open={open}
      setOpen={setOpen}
      title="Lista de requerimiento de certificado a eliminar"
      action={confirmRequires}
      actionText="Aceptar"
    >
      <LimitedBackdrop open={openBackDrop}>
        <CircularProgress color="primary" />
      </LimitedBackdrop>
      <div className={classes.root}>
        <div className={classes.serviceSheetsHeader}>
          <div>Material</div>
          <div>Requiere Certificado</div>
        </div>

        {selectedRows.map((row) => (
          <div className={classes.serviceSheets} key={row.id}>
            <div>{row.name}</div>
            <div>{row.requiresCertificate ? "Si" : "No"}</div>
          </div>
        ))}
      </div>
    </DialogAcerBrag>
  );
};
export default MaterialsRequiresConfirmationDialog;
